// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { fetchProfile, logout } from "../redux/actions/authActions";
// import { markAttendance, resetAttendanceState } from "../redux/actions/attendanceActions";
// import { parseQrParams, buildQrQueryString } from "../utils/queryParams";
// import AuthCard from "../components/AuthCard";
// import Spinner from "../components/Spinner";

// export default function AttendancePage() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const { profile, isLoadingProfile, profileError } = useSelector((state) => state.auth);
//   const { isSubmitting, success, error, locationError } = useSelector((state) => state.attendance);

//   const [overNight, setOverNight] = useState(false);
//   const [showAlert, setShowAlert] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [alertType, setAlertType] = useState(""); // "success" or "error"
  
//   const qrParams = parseQrParams(location.search);

//   useEffect(() => {
//     dispatch(fetchProfile());
//     dispatch(resetAttendanceState());
//   }, []);

//   useEffect(() => {
//     if (success) {
//       setAlertType("success");
//       setAlertMessage(`✅ Attendance ${qrParams.attendType === 'in' ? 'Check In' : 'Check Out'} Successful!`);
//       setShowAlert(true);
      
//       const timer = setTimeout(() => {
//         setShowAlert(false);
//         setAlertMessage("");
//         dispatch(resetAttendanceState());
//       }, 5000);
      
//       return () => clearTimeout(timer);
//     }
//   }, [success, dispatch, qrParams]);

//   const handleAttend = async (attendType) => {
//     if (!("geolocation" in navigator)) {
//       alert("Geolocation is not supported on this device. Please use a different device.");
//       return;
//     }

//     const result = await dispatch(
//       markAttendance({
//         attendType,
//         lid: qrParams.lid,
//         bid: qrParams.bid,
//         overNight,
//       })
//     );

//     if (result === false && !success && error) {
//       setAlertType("error");
//       setAlertMessage(`❌ ${error || "Attendance failed. Please try again."}`);
//       setShowAlert(true);
      
//       // Auto-hide error alert after 5 seconds
//       const timer = setTimeout(() => {
//         setShowAlert(false);
//         setAlertMessage("");
//         dispatch(resetAttendanceState());
//       }, 5000);
      
//       return () => clearTimeout(timer);
//     }
//   };

//   const handleLogout = () => {
//     dispatch(logout());
//     navigate(`/login${buildQrQueryString(qrParams)}`, { replace: true });
//   };

//   const username = localStorage.getItem("username") || profile?.userName || "";

//   // Function to close alert manually
//   const closeAlert = () => {
//     setShowAlert(false);
//     setAlertMessage("");
//     dispatch(resetAttendanceState());
//   };

//   return (
//     <AuthCard
//       title="Attendance Portal"
//       headerAction={
//         <button
//           type="button"
//           onClick={handleLogout}
//           className="flex items-center gap-1.5 text-sm font-semibold text-brand-navy/70 hover:text-brand-navy transition-colors"
//         >
//           <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
//             <path strokeLinecap="round" strokeLinejoin="round" d="M16 17l5-5-5-5" />
//             <path strokeLinecap="round" strokeLinejoin="round" d="M21 12H9" />
//           </svg>
//           Logout
//         </button>
//       }
//     >
//       <div className="flex flex-col gap-8">
//         <div className="text-center">
//           <p className="text-brand-text text-sm leading-relaxed">
//             Hello,
//             You have logged in as{" "}
//             <span className="font-semibold text-brand-navy">{username}</span>
//           </p>
//         </div>

//         {/* Custom Alert Messages */}
//         {showAlert && (
//           <div className={`border rounded-xl p-4 text-center relative ${
//             alertType === "success" 
//               ? "bg-green-50 border-green-200" 
//               : "bg-red-50 border-red-200"
//           }`}>
//             <button
//               onClick={closeAlert}
//               className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
//             >
//               ✕
//             </button>
//             <p className={`text-sm font-medium ${
//               alertType === "success" ? "text-green-700" : "text-red-700"
//             }`}>
//               {alertMessage}
//             </p>
//           </div>
//         )}

//         {/* Show location error prominently */}
//         {locationError && (
//           <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
//             <p className="text-sm text-red-700 font-medium">
//               ⚠️ Location Error
//             </p>
//             <p className="text-sm text-red-600 mt-1">{locationError}</p>
//             <button
//               onClick={() => window.location.reload()}
//               className="mt-2 text-sm text-brand-navy underline hover:no-underline"
//             >
//               Retry
//             </button>
//           </div>
//         )}

//         {error && !showAlert && (
//           <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2 text-center">
//             {error}
//           </p>
//         )}

//         <div className="flex flex-col sm:flex-row gap-4">
//           <button
//             type="button"
//             onClick={() => handleAttend("in")}
//             disabled={isSubmitting || showAlert}
//             className="flex-1 flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-gold-dark disabled:opacity-70 transition-colors text-brand-navy font-bold rounded-3xl py-3.5 text-lg"
//           >
//             {isSubmitting && <Spinner className="w-5 h-5" />}
//             Check In
//           </button>
//           <button
//             type="button"
//             onClick={() => handleAttend("out")}
//             disabled={isSubmitting || showAlert}
//             className="flex-1 flex items-center justify-center gap-2 bg-brand-navy hover:bg-brand-navy-dark disabled:opacity-70 transition-colors text-white font-bold rounded-3xl py-3.5 text-lg"
//           >
//             {isSubmitting && <Spinner className="w-5 h-5" />}
//             Check Out
//           </button>
//         </div>

//         <label className="flex items-center justify-center gap-2 text-brand-text cursor-pointer select-none">
//           <input
//             type="checkbox"
//             checked={overNight}
//             onChange={(e) => setOverNight(e.target.checked)}
//             disabled={showAlert}
//             className="w-4 h-4 accent-brand-navy"
//           />
//           Over Time
//         </label>
//       </div>
//     </AuthCard>
//   );
// }




import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchProfile, logout } from "../redux/actions/authActions";
import { 
  markAttendance, 
  resetAttendanceState,
  fetchAttendanceHistory 
} from "../redux/actions/attendanceActions";
import { parseQrParams, buildQrQueryString } from "../utils/queryParams";
import AuthCard from "../components/AuthCard";
import Spinner from "../components/Spinner";

export default function AttendancePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { profile, isLoadingProfile, profileError } = useSelector((state) => state.auth);
  const { 
    isSubmitting, 
    success, 
    error, 
    locationError,
    history,
    isFetchingHistory,
    historyError
  } = useSelector((state) => state.attendance);

  const [overNight, setOverNight] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  
  const qrParams = parseQrParams(location.search);

  useEffect(() => {
    dispatch(fetchProfile());
    dispatch(resetAttendanceState());
    dispatch(fetchAttendanceHistory());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchAttendanceHistory());
    }
  }, [success, dispatch]);

  useEffect(() => {
    if (success) {
      setAlertType("success");
      setAlertMessage(`Attendance ${qrParams.attendType === 'in' ? 'Check In' : 'Check Out'} Successful!`);
      setShowAlert(true);
      
      const timer = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
        dispatch(resetAttendanceState());
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [success, dispatch, qrParams]);

  const handleAttend = async (attendType) => {
    if (!("geolocation" in navigator)) {
      alert("Geolocation is not supported on this device. Please use a different device.");
      return;
    }

    const result = await dispatch(
      markAttendance({
        attendType,
        lid: qrParams.lid,
        bid: qrParams.bid,
        overNight,
      })
    );

    if (result === false && !success && error) {
      setAlertType("error");
      setAlertMessage(`${error || "Attendance failed. Please try again."}`);
      setShowAlert(true);
      
      const timer = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
        dispatch(resetAttendanceState());
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate(`/login${buildQrQueryString(qrParams)}`, { replace: true });
  };

  const username = localStorage.getItem("username") || profile?.userName || "";

  const closeAlert = () => {
    setShowAlert(false);
    setAlertMessage("");
    dispatch(resetAttendanceState());
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return 'N/A';
    const [hours, minutes] = timeStr.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const getStatusKind = (status) => {
    const s = status?.toString() || '';
    if (s.includes('Pending') || s.includes('⏳')) return 'pending';
    if (s.toLowerCase().includes('valid') && !s.includes('❌')) return 'valid';
    return 'invalid';
  };

  const handleToggleHistory = () => {
    const opening = !showHistory;
    setShowHistory(opening);
    if (opening) {
      dispatch(fetchAttendanceHistory());
    }
  };
  const DirectionIcon = ({ inout }) => {
    const checkedIn = inout === 'Check In';
    return (
      <span
        className={`flex items-center justify-center w-8 h-8 rounded-full shrink-0 ${
          checkedIn ? 'bg-emerald-100 text-emerald-600' : 'bg-brand-navy/10 text-brand-navy'
        }`}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" className="w-4 h-4">
          {checkedIn ? (
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 19V5M6 11l6-6 6 6" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14M6 13l6 6 6-6" />
          )}
        </svg>
      </span>
    );
  };

  return (
    <AuthCard
      title="Attendance Portal"
      headerAction={
        <button
          type="button"
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-sm font-semibold text-brand-navy/70 hover:text-brand-navy transition-colors"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 17l5-5-5-5" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12H9" />
          </svg>
          Logout
        </button>
      }
    >
      <div className="flex flex-col gap-6">
        <div className="text-center">
          <p className="text-brand-text text-sm leading-relaxed">
            Hello,
            You have logged in as{" "}
            <span className="font-semibold text-brand-navy">{username}</span>
          </p>
        </div>

        {/* Toggle History Button */}
        <button
          onClick={handleToggleHistory}
          className="w-full flex items-center justify-between gap-2 rounded-xl border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors px-4 py-2.5 text-sm font-medium text-brand-navy"
        >
          <span className="flex items-center gap-2">
            Recent Attendance
            {isFetchingHistory && <Spinner className="w-3.5 h-3.5" />}
          </span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            className={`w-4 h-4 transition-transform duration-200 ${showHistory ? 'rotate-180' : ''}`}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 9l6 6 6-6" />
          </svg>
        </button>

        {/* Attendance History - unified timeline list */}
        {showHistory && (
          <div className="rounded-xl border border-gray-200 overflow-hidden">
            {isFetchingHistory ? (
              <div className="text-center py-6">
                <Spinner className="w-6 h-6 mx-auto" />
                <p className="text-sm text-gray-500 mt-2">Loading history...</p>
              </div>
            ) : historyError ? (
              <div className="text-center py-6">
                <p className="text-sm text-red-600">{historyError}</p>
                <button
                  onClick={() => dispatch(fetchAttendanceHistory())}
                  className="mt-2 text-sm text-brand-navy underline hover:no-underline"
                >
                  Retry
                </button>
              </div>
            ) : history.length === 0 ? (
              <div className="text-center py-6">
                <p className="text-sm text-gray-500">No attendance records found</p>
              </div>
            ) : (
              <ul className="divide-y divide-gray-100 bg-white">
                {history.map((record, index) => {
                  const statusKind = getStatusKind(record.status);
                  const badgeClasses = {
                    valid: 'bg-emerald-50 text-emerald-700',
                    invalid: 'bg-red-50 text-red-700',
                    pending: 'bg-amber-50 text-amber-700',
                  }[statusKind];
                  const dotClasses = {
                    valid: 'bg-emerald-500',
                    invalid: 'bg-red-500',
                    pending: 'bg-amber-500',
                  }[statusKind];
                  const label = {
                    valid: 'Valid',
                    invalid: 'Invalid',
                    pending: 'Pending',
                  }[statusKind];
                  return (
                    <li key={index} className="flex items-center gap-3 px-4 py-3">
                      <DirectionIcon inout={record.inout} />

                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between gap-2">
                          <p className="text-sm font-semibold text-brand-navy truncate">
                            {record.inout}
                          </p>
                          <p className="text-xs text-gray-500 whitespace-nowrap">
                            {formatTime(record.time)}
                          </p>
                        </div>
                        <div className="flex items-center gap-3 mt-0.5 text-xs text-gray-500">
                          <span>{record.distance} away</span>
                          {record.overNights && record.overNights !== '-' && (
                            <span className="text-gray-400">· OT: {record.overNights}</span>
                          )}
                        </div>
                      </div>

                      <span
                        className={`flex items-center gap-1 text-xs font-medium px-2 py-1 rounded-full shrink-0 ${badgeClasses}`}
                      >
                        <span className={`w-1.5 h-1.5 rounded-full ${dotClasses}`} />
                        {label}
                      </span>
                    </li>
                  );
                })}
              </ul>
            )}

            {!isFetchingHistory && !historyError && history.length > 0 && (
              <div className="bg-gray-50 border-t border-gray-100 py-2 text-center text-xs text-gray-400">
                Showing last {history.length} records
              </div>
            )}
          </div>
        )}

        {/* Custom Alert Messages */}
        {showAlert && (
          <div className={`border rounded-xl p-4 text-center relative ${
            alertType === "success" 
              ? "bg-green-50 border-green-200" 
              : "bg-red-50 border-red-200"
          }`}>
            <button
              onClick={closeAlert}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <p className={`text-sm font-medium ${
              alertType === "success" ? "text-green-700" : "text-red-700"
            }`}>
              {alertMessage}
            </p>
          </div>
        )}

        {/* Show location error prominently */}
        {locationError && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4 text-center">
            <p className="text-sm text-red-700 font-medium">
              ⚠️ Location Error
            </p>
            <p className="text-sm text-red-600 mt-1">{locationError}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-2 text-sm text-brand-navy underline hover:no-underline"
            >
              Retry
            </button>
          </div>
        )}

        {error && !showAlert && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2 text-center">
            {error}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            type="button"
            onClick={() => handleAttend("in")}
            disabled={isSubmitting || showAlert}
            className="flex-1 flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-gold-dark disabled:opacity-70 transition-colors text-brand-navy font-bold rounded-3xl py-3.5 text-lg"
          >
            {isSubmitting && <Spinner className="w-5 h-5" />}
            Check In
          </button>
          <button
            type="button"
            onClick={() => handleAttend("out")}
            disabled={isSubmitting || showAlert}
            className="flex-1 flex items-center justify-center gap-2 bg-brand-navy hover:bg-brand-navy-dark disabled:opacity-70 transition-colors text-white font-bold rounded-3xl py-3.5 text-lg"
          >
            {isSubmitting && <Spinner className="w-5 h-5" />}
            Check Out
          </button>
        </div>

        <label className="flex items-center justify-center gap-2 text-brand-text cursor-pointer select-none">
          <input
            type="checkbox"
            checked={overNight}
            onChange={(e) => setOverNight(e.target.checked)}
            disabled={showAlert}
            className="w-4 h-4 accent-brand-navy"
          />
          Over Time
        </label>
      </div>
    </AuthCard>
  );
}